import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ToastProvider } from './components/Toast.jsx'
import App from './App.jsx'
import './index.css'
import { startVersionWatch } from './lib/versionWatch.js'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <App />
      </ToastProvider>
    </BrowserRouter>
  </React.StrictMode>,
)

/* Watch for a redeploy and reload this tab onto the new build. Started after
   render so it never delays first paint. */
startVersionWatch()
